import { eTuiThiActionIds, ITuiThiActionTypeBase, ITuiThiActionTypes } from './../../action-types/tct/ITuiThiActions';

import { call, put, takeEvery } from "redux-saga/effects";
import { thiSinhApi } from "../../../api/tct/thiSinhApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { IThiSinhSelectDanhPhachVmRequest } from '../../../model/request/tct/IThiSinhSelectDanhPhachVmRequest';
const mainAction = rootActions.toChucThi.tuiThi;
export function* tuiThiSaga(): any {
    yield takeEvery(eTuiThiActionIds.LOAD_THISINH_START, loadWorker)

}

function* loadWorker(action: ITuiThiActionTypes): any {
    const payload = action.payload as ITuiThiActionTypeBase<IThiSinhSelectDanhPhachVmRequest>
    const res: IBaseRespone = yield call(thiSinhApi.SelectByPhongs, payload.data)
    if (res.is_success) {
        yield put(mainAction.LOAD_THISINH_SUCCESS({
            data: res.data,
            dotThiId: payload.dotThiId
        }))
    } else {
        yield put(mainAction.LOAD_THISINH_ERROR({
            data: res.message ?? "Có lỗi",
            dotThiId: payload.dotThiId
        }))
    }
}
